import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./anfrageStyle.css";
import "aos/dist/aos.css";
import { ToastContainer, toast } from "react-toastify";
import Cookies from "js-cookie";

export default function PasswordReset() {
    const navigate = useNavigate();

    const [step, setStep] = useState(1);
    const [eventSize, setEventSize] = useState(null);
    const [eventTyp, setEventTyp] = useState(null);
    const [anfrageText, setAnfrageText] = useState("");
    const [email, setEmail] = useState("");
    const [name, setName] = useState("");

    useEffect(() => {
        document.title = "DJ - EMAN"
    }, []);

    function switchSide(side) {
        navigate(side);
    }

    function previourStep() {
        setStep(step - 1);
    }

    function nextStep() {
        setStep(step + 1);
    }

    const handleSendAnfrage = async (e) => {
        e.preventDefault();

        const anfrageData = {
            name: name,
            email: email,
            anfrageText: anfrageText,
            eventSize: eventSize,
            eventTyp: eventTyp,
        }

        try {
            const response = await fetch("https://djeman.de:8443/api/v1/sendbookinganfrage", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(anfrageData),
            });

            if (response.status == 200) {
                toast.success("Deine Anfrage wurde erfolgreich gesendet");
            } else if (response.status == 409) {
                toast.error(await response.text());
            } else {
                toast.error("Beim senden deiner Anfrage ist ein Fehler aufgetreten");
            }
        } catch (error) {
            console.error("Fehler beim API Request: ", error);
        }

        setStep(1);
        setName("");
        setEmail("");
        setAnfrageText("");
        setEventSize(null);
        setEventTyp(null);
    }

    return (
        <div className="anfrageContainer">
            <ToastContainer
                theme="dark"
            />
            <h1>Booking Anfrage</h1>
            <h2>Stelle noch heute innerhalb weniger Minuten eine Anfrage</h2>
            <div className="anfrageDataContainer">
                    {step === 1 && (
                        <>
                            <h3>Event größe</h3>
                            <form onSubmit={nextStep}>
                                <div className="eventSizesContainer">
                                    <div onClick={() => {setEventSize(1); nextStep();}} className={"eventSizeContainer" + (eventSize === 1 ? " mark" : "")}>
                                        <img src="/img/size.svg" />
                                        <h1>50 - 150 Personen</h1>
                                    </div>
                                    <div onClick={() => {setEventSize(2); nextStep();}} className={"eventSizeContainer" + (eventSize === 2 ? " mark" : "")}>
                                        <img src="/img/size.svg" />
                                        <h1>150 - 500 Personen</h1>
                                    </div>
                                    <div onClick={() => {setEventSize(3); nextStep();}} className={"eventSizeContainer" + (eventSize === 3 ? " mark" : "")}>
                                        <img src="/img/size.svg" />
                                        <h1>500 - 2.000 Personen</h1>
                                    </div>
                                </div>
                                <div className="buttonContainer">
                                    <div />
                                    <button type="submit">Weiter</button>
                                </div>
                            </form>
                        </>
                    )}
                    {step === 2 && (
                        <>
                            <h3>Event typ</h3>
                            <form onSubmit={nextStep}>
                                <div className="eventSizesContainer">
                                    <div onClick={() => {setEventTyp(1); nextStep()}} className={"eventSizeContainer" + (eventTyp === 1 ? " mark" : "")}>
                                        <img src="/img/headphones.svg" />
                                        <h1>Club, DJ Booking</h1>
                                    </div>
                                    <div onClick={() => {setEventTyp(2); nextStep()}} className={"eventSizeContainer" + (eventTyp === 2 ? " mark" : "")}>
                                        <img src="/img/gift.svg" />
                                        <h1>Hochzeit, Geburtstag, <br />Firmenevent</h1>
                                    </div>
                                    <div onClick={() => {setEventTyp(3); nextStep()}} className={"eventSizeContainer" + (eventTyp === 3 ? " mark" : "")}>
                                        <img src="/img/truckRamp.svg" />
                                        <h1>Technik, Beschallung,<br /> Beleuchtung</h1>
                                    </div>
                                </div>
                                <div className="buttonContainer">
                                    <button onClick={() => previourStep()}>Zurück</button>
                                    <button type="submit">Weiter</button>
                                </div>
                            </form>
                        </>
                    )}
                    {step === 3 && (
                        <>
                            <h3>Beschreibung</h3>
                            <form onSubmit={handleSendAnfrage}>
                                <textarea
                                    type="text"
                                    placeholder="Anfrage"
                                    value={anfrageText}
                                    onChange={(e) => setAnfrageText(e.target.value)}
                                />
                                <input
                                    type="text"
                                    placeholder="E-Mail"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                />
                                <input
                                    type="text"
                                    placeholder="Nachname & Vorname"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                />
                                <div className="buttonContainer">
                                    <button onClick={() => previourStep()}>Zurück</button>
                                    <button type="submit">Anfragen</button>
                                </div>
                            </form>
                        </>
                    )}
            </div>
            <h1>Ablauf eines Events</h1>
            <h3 data-aos="fade-right">1. Vorgespräch</h3>
            <h4 data-aos="fade-right">Nachdem ich vorab geprüft habe, ob ich an dem von euch gewünschten Datum noch verfügbar bin, treffen wir uns zu einem unverbindlichen Vorgespräch. Dabei besprechen wir euren Musikstil und eure Vorstellungen.</h4>
            <h3 data-aos="fade-right">2. Angebot</h3>
            <h4 data-aos="fade-right">Im Anschluss an unser Gespräch schicke ich Euch ein konkretes Angebot gemäß eurer individuellen Bedürfnisse. Wenn ihr mich als euren DJ buchen möchtet, schließen wir einen schriftlichen Vertrag. Ab sofort bin ich euer Ansprechpartner für sämtliche Fragen rund um die Musik. Einige Fragen beantworte ich auch vorab per E-Mail und telefonisch.</h4>
            <h3 data-aos="fade-right">3. Kurz vor dem Event</h3>
            <h4 data-aos="fade-right">Gerne kann eine Liste mit max. 25 Wunschtiteln oder auch mit max. 25 unerwünschten Songtiteln erstellt werden.</h4>
            <h3 data-aos="fade-right">4. An- und Abfahrt</h3>
            <h4 data-aos="fade-right">Im Preis inbegriffen ist eine An- und Abfahrt im Umkreis von 50 km um Hof. Darüber hinaus werden 0,50 Euro pro gefahrenen Kilometer berechnet.</h4>
            <h3 data-aos="fade-right">5. Aufbau</h3>
            <h4 data-aos="fade-right">2 Stunden vor Arbeitsbeginn bin ich pünktlich an der Location und baue das nötige Equipment auf.</h4>
            <h3 data-aos="fade-right">6. Party</h3>
            <h4 data-aos="fade-right">Ich begleite euer Event mit den richtigen Songs und sorge dafür, dass niemand so schnell die Tanzfläche verlässt.</h4>
            <h3 data-aos="fade-right">7. Abbau</h3>
            <h4 data-aos="fade-right">Nach dem Ende des Gigs baue ich noch am selben Abend das gesamte Equipment wieder ab.</h4>
            <h3 data-aos="fade-right">8. Nach dem Event</h3>
            <h4 data-aos="fade-right">Auf Wunsch erstelle ich gerne einen Mitschnitt aller gespielten Songs des Abends und stelle Ihnen diesen anschließend zur Verfügung.</h4>
        </div>
    )
}
